import React from 'react';

import { DropdownItem } from 'reactstrap';

import ReduxConnect from 'Demora/redux-connect';

import http from 'Demora/http';

import { Link } from 'react-router-dom';

class ProfileOptions extends React.Component {
	constructor(props) {
		super();

		let obj = props.obj;

		let objS = obj.split('-');

		this.state = {
			obj: obj,
			objS: objS,
			allow: undefined,
			changingState: false,
		};
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	componentDidMount() {
		let state = this.state;

		if (state.objS[1] !== 'u') {
			return null;
		}

		http.get('/data/getCanMessage/' + state.objS[0]).then((data) => {
			if (!this.unmounted) {
				this.setState({
					allow: data.can_message,
				});
			}
		});
	}

	changeCanMessage = () => {
		let state = this.state;

		if (state.changingState) {
			return;
		}

		let allow = !state.allow;

		http
			.post('/data/changeCanMessage/' + this.state.objS[0], { state: allow })
			.then((data) => {
				if (!this.unmounted) {
					this.setState({
						changingState: false,
						allow: allow,
					});
				}
			});

		this.setState({
			changingState: true,
			allow: undefined,
		});
	};

	render() {
		let props = this.props;

		let user = props.user;

		let state = this.state;

		let obj = state.obj;

		if (state.objS[1] !== 'u') {
			return null;
		}

		if (user.id && user.id == state.objS[0]) {
			return (
				<Link to='/settings/editProfile'>
					<DropdownItem>
						<i className='fa fa-cog' />
						&nbsp;Edit Profile
					</DropdownItem>
				</Link>
			);
		}

		return (
			<DropdownItem>
				{state.allow == undefined ? (
					<div className='text-center'>
						<i className='fa fa-cog fa-spin' />
					</div>
				) : (
					<div onClick={this.changeCanMessage}>
						<i className='fas fa-envelope' />
						&nbsp; {state.allow ? 'Block' : 'Allow'} messages from{' '}
						{props.users[obj].first_name}
					</div>
				)}
			</DropdownItem>
		);
	}
}

export default ReduxConnect(ProfileOptions, {
	user: 'user',
	users: 'users',
});
